<template>
  <el-tabs value="tab1" type="card" @tab-click="changeTab">
    <el-tab-pane label="控制柜料号" name="tab1">
      <thk-material-box-list ref="tabBox"/>
    </el-tab-pane>
     <el-tab-pane label="马达额定转速" name="tab2">
      <thk-material-zhuansu-list ref="tabZhuansu"/>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
  import ThkMaterialBoxList from "@/views/information/ThkMaterial/ThkMaterialBoxList.vue";
  import ThkMaterialZhuansuList from "@/views/information/ThkMaterial/ThkMaterialZhuansuList.vue";

  export default {
    name: "ThkMaterialTabs",
    components: {ThkMaterialBoxList,ThkMaterialZhuansuList},

    methods:{
      changeTab(name){
        if(name == "tab1"){
          this.$refs.tabBox.getList(1);
        }
        else if(name == "tab2"){
          this.$refs.tabZhuansu.getList(1);
        }
      },
    },
  };
</script>

<style scoped lang="scss">

</style>